<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <br>
      </p>
      <p>
        <span style="font-size:10.5pt;font-family:&quot;color:black;">
          <strong>
            <u>Линия</u>
          </strong>
        </span>
        <span style="font-size:10.5pt;font-family:&quot;color:black;"></span>
        <span style="font-size:10.5pt;font-family:&quot;color:black;">
          <strong>
            <u>непрерывной</u>
          </strong>
        </span>
        <span style="font-size:10.5pt;font-family:&quot;color:black;"></span>
        <span style="font-size:10.5pt;font-family:&quot;color:black;">
          <strong>
            <u>разливки</u>
          </strong>
        </span>
        <span style="font-size:10.5pt;font-family:&quot;color:black;"></span>
        <span style="font-size:10.5pt;font-family:&quot;color:black;">
          <strong>
            <u>и</u>
          </strong>
        </span>
        <span style="font-size:10.5pt;font-family:&quot;color:black;"></span>
        <span style="font-size:10.5pt;font-family:&quot;color:black;">
          <strong>
            <u>прокатки</u>
          </strong>
        </span>
        <span style="font-size:10.5pt;font-family:&quot;color:black;"></span>
        <span style="font-size:10.5pt;font-family:&quot;color:black;">
          <strong>
            <u>алюминиевых</u>
          </strong>
        </span>
        <span style="font-size:10.5pt;font-family:&quot;color:black;"></span>
        <span style="font-size:10.5pt;font-family:&quot;color:black;">
          <strong>
            <u>прутков</u>
          </strong>
        </span>
      </p>
      <p>
        <span style="font-size:10.5pt;font-family:&quot;color:black;">
          <strong>
            <u>
              <br>
            </u>
          </strong>
        </span>
      </p>
      <p>
        <span style="font-size:10.5pt;font-family:&quot;color:black;">
          <strong>
            <u></u>
          </strong>
        </span>
      </p>
      <p style="white-space:normal;">
        <strong>
          <u>
            <img :src="images.lglz" alt style="line-height:1.5;">
            <span style="line-height:1.5;">&nbsp;</span>
          </u>
        </strong>
      </p>
      <strong>
        <u>
          <p style="white-space:normal;">
            <br>
          </p>
          <p style="white-space:normal;">
            <b>
              <span
                style="font-family:Arial;font-size:18px;"
              >Continues casting and rolling production line for Aluminum Rods</span>
            </b>
          </p>
          <p style="white-space:normal;">
            <span style="font-family:'color:black;">
              <br>
            </span>
          </p>
          <p style="white-space:normal;">
            <span style="font-family:Arial;">1</span>
            <span style="font-family:Arial;">.</span>
            <span
              style="font-family:Arial;"
            >&nbsp;Aluminum pole continue casting direct rolling production line is used for producing high strength conductive alloy pole like aluminum pole, al-mg alloy and al-mg-si alloy with diameter 9.5mm and 12mm etc, it could be match other similar products around the world.</span>
          </p>
          <p style="white-space:normal;">
            <span style="font-family:'color:black;">
              <br>
            </span>
          </p>
          <p style="white-space:normal;">
            <span style="font-family:Arial;">2</span>
            <span style="font-family:Arial;">.&nbsp;</span>
            <span
              style="font-family:Arial;"
            >It used circular fast energy-saving aluminum melting furnace with permanent magnet stirrer, in order to equipping, uniform and refining of aluminum alloy.</span>
          </p>
          <p style="white-space:normal;">
            <span style="font-family:宋体;">
              <br>
            </span>
          </p>
          <p style="white-space:normal;">
            <span style="font-family:Arial;">3.&nbsp;</span>
            <span
              style="font-family:Arial;"
            >It used the way of casting on flat, when casting, the liquid of aluminum alloy flew smoothly from middle pot to crystallizing wheel, to avoid turbulence.</span>
          </p>
          <p style="white-space:normal;">
            <span style="font-family:宋体;">
              <br>
            </span>
          </p>
          <p style="white-space:normal;">
            <span style="font-family:Arial;">4.&nbsp;</span>
            <span
              style="font-family:Arial;"
            >Tandem mill system used the rolling way of two-roller and three-roller combined, it was helped for roll compacting and deformation of ingot casting. This system could insure the ingot blank stress uniform.</span>
          </p>
          <p style="white-space:normal;">
            <span style="font-family:'color:black;"></span>
            <span style="font-family:宋体;">
              <br>
            </span>
          </p>
          <p style="white-space:normal;">
            <span style="font-family:Arial;">5.</span>
            <span
              style="font-family:Arial;"
            >&nbsp;This production line transmission used siemens digital dc timing device. The PLC could command and coordination the whole system accurately and reliably in the control part, main and auxiliaries gang controlled all line, high control accuracy, low failure, easy maintenance, system is stable and reliable. Operating with human-machine interface, which easy to send instruction, check running status of equipment, set, modify, display the device parameters, and have the function of fault diagnosis.</span>
          </p>
          <div>
            <br>
          </div>
        </u>
      </strong>
      <p></p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        lglz: require("../../../assets/img/common/lglz.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/device/lglz.vue